import { render, staticRenderFns } from "./consignor.vue?vue&type=template&id=25a85af4&"
import script from "./consignor.vue?vue&type=script&lang=js&"
export * from "./consignor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports